import { useLocales } from "@/locales";
import { CommonWrap } from "@/PageComponents/common";
import ContentWrap from "@/DocLayout/Content/Index";
import { Box, Link } from "@mui/material";
import { Trans } from "react-i18next";
import {
  TELEGRAM_SUPPORT_URL,
  TWITTER_SUPPORT_URL,
  EMAIL_SUPPORT_URL,
} from "@/config";

export default function ContactUs() {
  const { translate } = useLocales();
  return (
    <ContentWrap
      // showBorderBottom={false}
      leftChildrenSx={{
        paddingTop: "1px",
        // paddingBottom: "32px",
      }}
      leftChildren={
        <CommonWrap>
          <Box id="contact-us" component={"div"} className="title_0">
            {translate("support_help.contact_us_title")}
          </Box>
          <Box component={"div"} className="desc">
            {translate("support_help.contact_us_desc")}
          </Box>

          <>
            <Box component={"div"} className="desc">
              <Trans
                i18nKey={"support_help.contact_us_link_tg"}
                t={translate as any}
              >
                Just a placeholder
                <Link
                  underline="always"
                  target="_blank"
                  href={TELEGRAM_SUPPORT_URL}
                  className="link"
                >
                  Just a placeholder
                </Link>
              </Trans>
            </Box>
            <Box component={"div"} className="desc">
              <Trans
                i18nKey={"support_help.contact_us_link_tw"}
                t={translate as any}
              >
                Just a placeholder
                <Link
                  underline="always"
                  target="_blank"
                  href={TWITTER_SUPPORT_URL}
                  className="link"
                >
                  Just a placeholder
                </Link>
              </Trans>
            </Box>
            <Box component={"div"} className="desc">
              <Trans
                i18nKey={"support_help.contact_us_link_email"}
                t={translate as any}
              >
                Just a placeholder
                <Link
                  underline="always"
                  href={EMAIL_SUPPORT_URL}
                  className="link"
                  component={"a"}
                >
                  Just a placeholder
                </Link>
              </Trans>
            </Box>
          </>
        </CommonWrap>
      }
    />
  );
}
